


















































































































import { PageModule } from "@/store/module/page";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() rangeType!: string;
  @Prop() showSelect!: boolean;
  @Prop() startTime!: string;
  @Prop() endTime!: string;
  @Prop() dayTime!: string;
  @Prop() id!: number;
  currentRangeStart: number = 0;
  currentRangeEnd: number = 0;
  currentType: string = "week";
  isCurrent: boolean = true;
  viewMode: number = 1;
  showViewMode: boolean = true;
  cacheDate: any = {};
  classroomDate: any = {};
  month_value = "";
  week_value = "";
  day_value = "";
  mounted() {
    const cache = PageModule.pageInfo.sechduleTime;
    if (this.rangeType === "all") {
      if (cache.timeType) {
        this.currentType = cache.timeType;
      }
    } else {
      this.currentType = this.rangeType;
    }
    if (cache.viewMode) {
      this.viewMode = cache.viewMode;
      // this.$nextTick(() => {
      //   // this.handleViewModeChange(cache.viewMode);
      // });
    }
    const now = new Date();
    this.currentRangeStart = this.getStartTime(now); //获取当前时间段的开始
    this.currentRangeEnd = this.getEndTime(now); //获取当前时间段的结束
    // 初始化返回值
    this.$emit("update", {
      type: this.currentType,
      range: [this.currentRangeStart, this.currentRangeEnd],
    });
    eventBus.$on("schecule-switch-to-day-view", (date: string) => {
      this.currentType = "day";
      const target = new Date(date.replace(/-/g, "/"));
      const start = this.getStartTime(target);
      const end = this.getEndTime(target);
      this.currentRangeStart = start;
      this.currentRangeEnd = end;
      this.emitRange(start, end);
      if (start <= now.getTime() && end >= now.getTime()) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      PageModule.SET_PAGE_INFO({
        name: "sechduleTime",
        key: "timeType",
        value: "day",
      });
      return;
    });
    eventBus.$on("to-classroom-go-week-view", (obj: any) => {
      this.viewMode = 2;
      this.handleViewModeChange(2);
      this.handleTypeChange("day");
      return;
    });
    eventBus.$on("to-teacher-go-week-view", (obj: any) => {
      this.viewMode = 2;
      this.handleViewModeChange(2);
      this.handleTypeChange("week");
      return;
    });
    eventBus.$on("to-teacher-go-time-day-view", (obj: any) => {
      this.viewMode = 1;
      this.handleViewModeChange(1);
      this.handleTypeChange("day");
      return;
    });
    // eventBus.$on("switch-time-tab", (num: number) => {
    //   this.viewMode = 1;
    //   this.handleViewModeChange(1);
    //   this.handleTypeChange("week");
    // });
    if (this.startTime && this.endTime) {
      this.currentRangeStart = Date.parse(this.startTime);
      this.currentRangeEnd = Date.parse(this.endTime);
    }
    const scheduleType = this.id; // 课表类型
    const date = PageModule.pageInfo.timeStoreDate; // 时间课表时间
    const classroomDate = PageModule.pageInfo.classroomStoreDate; // 教室课表时间
    if (date.times && scheduleType == 1) {
      if (date.times.morword) {
        this.currentType = date.times.morword;
      }
      this.currentRangeStart = date.times.startDate;
      this.currentRangeEnd = date.times.endDate;
      const cur: number = new Date().getTime();
      if (this.currentRangeStart <= cur && this.currentRangeEnd >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.emitRange(this.currentRangeStart, this.currentRangeEnd);
    } else if (classroomDate.classroomTime && scheduleType == 2) {
      this.currentRangeStart = classroomDate.classroomTime.startDate;
      this.currentRangeEnd = classroomDate.classroomTime.endDate;
      const cur: number = new Date().getTime();
      if (this.currentRangeStart <= cur && this.currentRangeEnd >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.emitRange(this.currentRangeStart, this.currentRangeEnd);
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  // 时间选择, 把时间组件隐藏,处理时间
  handleChangeTime(v: any) {
    if (this.currentType === "month") {
      this.month_value = this.replaceDate(this.month_value, "");
      this.currentRangeStart = new Date(
        this.replaceDate(this.month_value, "add_one")
      ).getTime();
    } else if (this.currentType === "week") {
      this.currentRangeStart =
        new Date(this.week_value).getTime() + 6 * 24 * 3600 * 1000;
      this.currentRangeEnd =
        new Date(this.week_value).getTime() + 12 * 24 * 3600 * 1000;
    } else if (this.currentType === "day") {
      this.currentRangeStart =
        new Date(this.day_value).getTime() + 24 * 3600 * 1000;
    }
    this.handlePrev();
  }
  // 处理时间格式,加一
  replaceDate(val: string, type: string) {
    const m =
      type === "add_one"
        ? Number(val.slice(5, 7)) + 1
        : Number(val.slice(5, 7));
    const mm: string = m > 10 ? String(m) : "0" + String(m);
    const mmm = val.replace(val.slice(5, 7), mm);
    return mmm;
  }
  dayOfTheWeek(v: any) {
    const date = new Date(v).getDay();
    const obj = ["日", "一", "二", "三", "四", "五", "六"];
    return obj[date];
  }
  handleViewModeChange(v: number) {
    PageModule.SET_PAGE_INFO({
      name: "sechduleTime",
      key: "viewMode",
      value: v,
    });
    eventBus.$emit("sechdule-view-mode-change", v);
  }
  format(time: number) {
    const date = new Date(time);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    return `${y}年${m < 10 ? "0" + m : m}月${d < 10 ? "0" + d : d}日`;
  }
  getStartTime(v: Date) {
    let str = "";
    if (this.currentType === "month") {
      // 找1号
      str = `${v.getFullYear()}-${v.getMonth() + 1}-1 00:00:00`;
    } else if (this.currentType === "week") {
      // 找周一
      const startDay = new Date(
        v.getTime() -
          (v.getDay() === 0 ? 6 : v.getDay() - 1) * 24 * 60 * 60 * 1000
      );
      str = `${startDay.getFullYear()}/${
        startDay.getMonth() + 1
      }/${startDay.getDate()} 00:00:00`;
    } else if (this.currentType === "day") {
      // 找当天0点
      str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 00:00:00`;
    }
    const res = new Date(str).getTime();
    return res;
  }
  getEndTime(v: Date) {
    let str = "";
    if (this.currentType === "month") {
      // 找当月最后一日
      let m = v.getMonth();
      let y = v.getFullYear();
      if (m === 11) {
        m = 1;
        y = y + 1;
      } else {
        m = m + 2;
      }
      const next = new Date(
        new Date(`${y}/${m}/1`).getTime() - 24 * 60 * 60 * 1000
      );
      str = `${next.getFullYear()}-${
        next.getMonth() + 1
      }-${next.getDate()} 23:39:39`;
    } else if (this.currentType === "week") {
      // 找周日
      const endDay = new Date(
        v.getTime() +
          (v.getDay() === 0 ? 0 : 7 - v.getDay()) * 24 * 60 * 60 * 1000
      );
      str = `${endDay.getFullYear()}/${
        endDay.getMonth() + 1
      }/${endDay.getDate()} 23:39:39`;
    } else if (this.currentType === "day") {
      // 找当天24点
      str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 23:39:39`;
    }
    const res = new Date(str).getTime();
    return res;
  }
  handleCurrent(v: any) {
    const now = new Date();
    const start = this.getStartTime(now);
    const end = this.getEndTime(now);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.emitRange(start, end);
    this.isCurrent = true;
    if (this.id === 1 && v === "click") {
      this.cacheDate.startDate = this.currentRangeStart;
      this.cacheDate.endDate = this.currentRangeEnd;
      this.cacheDate.type = this.id;
      this.cacheDate.morword = this.currentType;
      PageModule.SET_PAGE_INFO({
        name: "timeStoreDate",
        key: "times",
        value: this.cacheDate,
      });
    }
    if (this.id === 2 && v === "click") {
      this.classroomDate.startDate = this.currentRangeStart;
      this.classroomDate.endDate = this.currentRangeEnd;
      this.classroomDate.type = this.id;
      PageModule.SET_PAGE_INFO({
        name: "classroomStoreDate",
        key: "classroomTime",
        value: this.classroomDate,
      });
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  handlePrev() {
    const now = new Date(this.currentRangeStart);
    let target = new Date();
    if (this.currentType === "month") {
      let m = now.getMonth();
      let y = now.getFullYear();
      if (m === 0) {
        m = 12;
        y = y - 1;
      }
      target = new Date(`${y}/${m}/1`);
    } else if (this.currentType === "week") {
      target = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    } else if (this.currentType === "day") {
      target = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    }
    const start = this.getStartTime(target);
    const end = this.getEndTime(target);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.emitRange(start, end);
    const cur: number = new Date().getTime();
    if (start <= cur && end >= cur) {
      this.isCurrent = true;
    } else {
      this.isCurrent = false;
    }
    if (this.id === 1) {
      this.cacheDate.startDate = this.currentRangeStart;
      this.cacheDate.endDate = this.currentRangeEnd;
      this.cacheDate.type = this.id;
      this.cacheDate.morword = this.currentType;
      PageModule.SET_PAGE_INFO({
        name: "timeStoreDate",
        key: "times",
        value: this.cacheDate,
      });
    }
    if (this.id === 2) {
      this.classroomDate.startDate = this.currentRangeStart;
      this.classroomDate.endDate = this.currentRangeEnd;
      this.classroomDate.type = this.id;
      PageModule.SET_PAGE_INFO({
        name: "classroomStoreDate",
        key: "classroomTime",
        value: this.classroomDate,
      });
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  handleNext() {
    const now = new Date(this.currentRangeStart);
    let target = new Date();
    if (this.currentType === "month") {
      let m = now.getMonth();
      let y = now.getFullYear();
      if (m === 11) {
        m = 1;
        y = y + 1;
      } else {
        m = m + 2;
      }
      target = new Date(`${y}/${m}/1`);
    } else if (this.currentType === "week") {
      target = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    } else if (this.currentType === "day") {
      target = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    }
    const start = this.getStartTime(target);
    const end = this.getEndTime(target);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.emitRange(start, end);
    const cur: number = new Date().getTime();
    if (start <= cur && end >= cur) {
      this.isCurrent = true;
    } else {
      this.isCurrent = false;
    }
    if (this.id === 1) {
      this.cacheDate.startDate = this.currentRangeStart;
      this.cacheDate.endDate = this.currentRangeEnd;
      this.cacheDate.type = this.id;
      this.cacheDate.morword = this.currentType;
      PageModule.SET_PAGE_INFO({
        name: "timeStoreDate",
        key: "times",
        value: this.cacheDate,
      });
    }
    if (this.id === 2) {
      this.classroomDate.startDate = this.currentRangeStart;
      this.classroomDate.endDate = this.currentRangeEnd;
      this.classroomDate.type = this.id;
      PageModule.SET_PAGE_INFO({
        name: "classroomStoreDate",
        key: "classroomTime",
        value: this.classroomDate,
      });
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  handleTypeChange(e: string) {
    if (e !== "month") {
      sessionStorage.removeItem("cacheMonth");
    }
    this.currentType = e;
    if (e === "week") {
      this.week_value = dateFormat("YYYY-mm-dd", new Date().getTime());
    }
    this.handleCurrent("");
    PageModule.SET_PAGE_INFO({
      name: "sechduleTime",
      key: "timeType",
      value: e,
    });
  }
  emitRange(start: number, end: number) {
    // 返回时间段到日历，因为月视图需要展示上下月的接邻内容，所以特殊处理
    if (this.currentType === "month") {
      let sWeekDay = new Date(start).getDay();
      let eWeekDay = new Date(end).getDay();
      sWeekDay = sWeekDay === 0 ? 7 : sWeekDay;
      eWeekDay = eWeekDay === 0 ? 7 : eWeekDay;
      this.$emit("change", {
        type: this.currentType,
        range: [
          start - (sWeekDay - 1) * 24 * 60 * 60 * 1000,
          end + (7 - eWeekDay) * 24 * 60 * 60 * 1000,
        ],
      });
      sessionStorage.setItem(
        "cacheMonth",
        JSON.stringify({
          type: this.currentType,
          range: [
            start - (sWeekDay - 1) * 24 * 60 * 60 * 1000,
            end + (7 - eWeekDay) * 24 * 60 * 60 * 1000,
          ],
        })
      );
    } else {
      this.$emit("change", {
        type: this.currentType,
        range: [start, end],
      });
    }
  }
}
